module.exports = __webpack_public_path__ + "resources/img/img_vehicle_process2.a7dd22aa863bd26a9ca59b6ac87f80d9.png";